export function classList(...classes) {
    return classes.filter((item) => !!item).join(' ');
}

function scrollToSmoothlyCustom(posValue, timeValue, container) {
    // TODO: Add easing
    const currentPos = container ? container.scrollTop : window.pageYOffset;
    const scrollContainer = container || window;
    let start = null;
    const pos = posValue;
    let time = timeValue;
    if (time == null) time = 500;

    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        const progress = currentTime - start;
        if (currentPos < pos) {
            scrollContainer.scrollTo(0, ((pos - currentPos) * progress) / (time + currentPos));
        } else {
            scrollContainer.scrollTo(0, ((currentPos - (currentPos - pos)) * progress) / time);
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            scrollContainer.scrollTo(0, pos);
        }
    });
}

function browserSupportsSmoothScroll() {
    return getComputedStyle(document.body).scrollBehavior === 'smooth';
}

export function scrollToPageElement(selector, delay = 0, adjust = 20, container = null) {
    setTimeout(() => {
        let stepElement = null;

        if (selector instanceof Element || selector instanceof HTMLDocument) {
            stepElement = selector;
        } else if (selector.startsWith('#')) {
            stepElement = document.getElementById(selector.replace('#', ''));
        } else {
            const namedElements = document.getElementsByName(selector);

            if (namedElements) {
                // eslint-disable-next-line prefer-destructuring
                stepElement = namedElements[0];
            }
        }

        if (stepElement) {
            const scrollY = container ? container.scrollTop : window.scrollY;
            const containerElement = container ?? window;

            let stepYPosition = stepElement.getBoundingClientRect().top + window.scrollY - adjust;

            if (stepYPosition < 0) {
                stepYPosition += scrollY;
            }

            if (browserSupportsSmoothScroll()) {
                containerElement.scrollTo({
                    top: stepYPosition,
                    behavior: 'smooth',
                });
            } else {
                scrollToSmoothlyCustom(stepYPosition, 500, container);
            }
        }
    }, delay);
}

export function setPropertyValueRecursive(key, value, obj, defaultValue) {
    let ref = obj;
    if (!ref) ref = defaultValue;
    const keys = key.split('.');
    if (keys.length < 2) {
        ref[keys[0]] = value;
    } else {
        if (!ref[keys[0]]) ref[keys[0]] = {};
        ref = ref[keys.shift()];
        setPropertyValueRecursive(keys.join('.'), value, ref);
    }
}

export function getPropertyValueRecursive(key, obj) {
    const keys = key.split('.');
    if (keys.length < 2) {
        return obj[keys[0]];
    }

    try {
        const ref = obj[keys.shift()];
        return getPropertyValueRecursive(keys.join('.'), ref);
    } catch {
        return null;
    }
}

export function escapeHtml(unsafe) {
    if (!unsafe) {
        return unsafe;
    }

    return unsafe.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}

const newItemPrefix = '_new-';
export function getNewItemId(items) {
    const ids = items
        .filter((value) => value.id.startsWith(newItemPrefix))
        .map((item) => parseInt(item.id.replace(newItemPrefix, ''), 0));

    const newItemIndex = ids.length > 0 ? Math.max(...ids) + 1 : 1;
    return `${newItemPrefix}${newItemIndex}`;
}

export const toggleProductBoxContent = (elementIdValue) => {
    const hiddenElements = document.querySelectorAll(`#${elementIdValue} .hidden`);
    hiddenElements.forEach((el) => {
        el.classList.remove('hidden');
    });

    const moreAnchors = document.querySelectorAll(`#${elementIdValue} .moreAnchor`);
    moreAnchors.forEach((el) => {
        el.classList.add('hidden');
    });
};

export const getHtml = (html) => ({ __html: html });

export const scrollElementByIdIntoView = (id) => document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
